import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '@ui/button/button.component';

@Component({
	selector: 'app-reject-importing-matter',
	templateUrl: './reject-importing-matter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ButtonComponent],
})
export class RejectImportingMatterComponent {
	constructor(
		public warnBeforeImportDialog: MatDialogRef<RejectImportingMatterComponent>,
	) {}

	closeDialog() {
		this.warnBeforeImportDialog.close();
	}
}
